import { ReactNode } from "react";
import { useAuth } from "@/features/auth/model/AuthContext";
import { Navigate } from "react-router-dom";
import { Permission } from "@/shared/types/roles";

interface WithPermissionProps {
  children: ReactNode;
  permissions?: Permission[];
  mode?: 'hide' | 'disable' | 'readonly';
  redirectTo?: string;
  redirect?: boolean;
}

export function WithPermission({
  children,
  permissions,
  mode = 'hide',
  redirectTo = "/unauthorized",
  redirect = false
}: WithPermissionProps) {
  const { hasPermission, isAuthenticated, loading } = useAuth();

  // Se ainda está carregando, mostra loading
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#1A1A1A] text-white">
        Carregando...
      </div>
    );
  }

  // Se não está autenticado e tem permissões, redireciona para login
  if (!isAuthenticated && permissions && permissions.length > 0) {
    return <Navigate to="/auth" replace />;
  }

  if (!permissions) {
    return <>{children}</>;
  }

  const hasAccess = permissions.some(permission => hasPermission(permission));
  
  // Se TEM permissão, mostra normalmente
  if (hasAccess) {
    return <>{children}</>;
  }

  // Se NÃO TEM permissão, aplica o modo
  if (mode === 'hide') {
    return null;
  }

  if (mode === 'disable') {
    return (
      <div className="opacity-50 cursor-not-allowed pointer-events-none" title="Sem permissão">
        {children}
      </div>
    );
  }

  if (mode === 'readonly') {
    return (
      <div className="pointer-events-none opacity-75" title="Apenas visualização">
        {children}
      </div>
    );
  }

  // Se redirect está ativo, redireciona
  if (redirect) {
    return <Navigate to={redirectTo} />;
  }

  return null;
}